import authApi from "../../api/auth"
export default {
    state: {
        currentUser: null,
        currentUserRole: null,
        attemptUrl: null,
    },
    getters: {
        isAuthenticated: state => {
            return !!state.currentUser
        },
        getCurrentUser: state => {
            return state.currentUser
        },
        getCurrentUserRole: state => {
            return state.currentUserRole
        },
        getAttemptUrl: state => {
            return state.attemptUrl
        },
        isApplicant: state => {
            return state.currentUserRole === 'ROLE_APPLICANT'
        },
        isAdmin: state => {
            return state.currentUserRole === 'ROLE_ADMIN'
        },
        isRegistrator: state => {
            return state.currentUserRole === 'ROLE_SINGLE_WINDOW'
        },
        isLawyer: state => {
            return state.currentUserRole === 'ROLE_LAWYER'
        },
        isDirector: state => {
            return state.currentUserRole === 'ROLE_DIRECTOR'
        },
        isSubDirector: state => {
            return state.currentUserRole === 'ROLE_SUB_DIRECTOR'
        },
        isManager: state => {
            return state.currentUserRole === 'ROLE_MANAGER'
        },
        isEmployee: state => {
            return state.currentUserRole === 'ROLE_EMPLOYMENT'
        },
        isAccountant: state => {
            return state.currentUserRole === 'ROLE_ACCOUNTANT'
        },
    },
    mutations: {
        setCurrentUser(state, payload) {
            state.currentUser = payload

            if(state.currentUser) {
                if(state.currentUser.role) {
                    state.currentUserRole = state.currentUser.role
                } else {
                    state.currentUserRole = 'ROLE_APPLICANT'
                }
            } else {
                state.currentUserRole = null
            }
        },
        setAttemptUrl(state, payload) {
            state.attemptUrl = payload
        },
        setUserAvatar(state, payload) {
          state.currentUser.photo = payload
        }
    },
    actions: {
        login(context, credentials) {
            return new Promise((resolve, reject) => {
                authApi
                    .login(credentials)
                    .then(result => {
                        localStorage.setItem('accessToken', result.user.token)
                        context.dispatch('fetchCurrentUser')
                            .then((user) => {
                                resolve(user)
                            })
                    })
                    .catch((err) => {
                        reject(err)
                    })
            });
        },
        loginEmployee(context, credentials) {
            return new Promise((resolve, reject) => {
                authApi
                    .loginEmployee(credentials)
                    .then(result => {
                        localStorage.setItem('accessToken', result.user.token)
                        context.dispatch('fetchCurrentUser')
                            .then((user) => {
                                resolve(user)
                            })
                    })
                    .catch((err) => {
                        reject(err)
                    })
            });
        },
        loginWithEkyzmat(context, credentials) {
            return new Promise((resolve, reject) => {
                authApi
                    .checkEkyzmatLogin(credentials)
                    .then(response => {
                        localStorage.setItem('accessToken', response.data.user.token)
                        context.dispatch('fetchCurrentUser')
                            .then((user) => {
                                resolve(user)
                            })
                    })
                    .catch((err) => {
                        reject(err)
                    })
            });
        },
        fetchCurrentUser(context) {
            return new Promise((resolve, reject) => {
                authApi
                    .fetchCurrentUser()
                    .then(result => {
                        context.commit('setCurrentUser', result.data)
                        resolve(result.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        logout(context){
            return new Promise(resolve => {
                localStorage.removeItem('accessToken')
                context.commit('setCurrentUser', null)
                resolve()
            });
        }
    },
}
